import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";
import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";
import {FBRepeater} from "../../../Pro/Fields/Fields/FBRepeater/FBRepeater";
import {FBRepeaterModel} from "../../../Pro/Fields/Fields/FBRepeater/FBRepeater.Model";

export class GroupPricePerItemCalculator extends CalculatorBase{

    private CustomSalePrice:number;
    private CustomRegularPrice:number;

    constructor(public PriceManager:PriceManager) {
        super();
        this.CustomSalePrice=null;
        this.CustomRegularPrice=null;
        this.PriceManager.TotalUpdated.Subscribe(this,()=>this.ExecuteAndUpdate());

    }


    Initialize(field: FBRepeaterModel): this {

        (field as FBRepeaterModel).FieldValueChanged.Subscribe(this,()=>this.ExecuteAndUpdate());
        return super.Initialize(field);

    }

    public SetRegularPrice(price:any)
    {
        this.CustomRegularPrice=price;
        return this;
    }

    public SetSalePrice(price:any)
    {
        this.CustomSalePrice=price;
        return this;
    }


    UpdatePrice(newPrice: any, newSalePrice: any = '', newQuantity: number = 0, forceUpdate: boolean = false) {
        let result=super.UpdatePrice(newPrice, newSalePrice, newQuantity, forceUpdate);
        this.Field.Refresh();
        return result;
    }

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}   {
        if(value==null)
            value=this.Field.GetValue();

        let regularPriceToUse=this.CustomRegularPrice!=null?this.CustomRegularPrice:this.Field.GetRegularPrice();
        let salePriceToUse=this.CustomSalePrice!=null?this.CustomSalePrice:this.Field.GetSalePrice();

        if(salePriceToUse!='')
            salePriceToUse=NumericUtilities.ParseNumber(salePriceToUse)*value.length;

        if(regularPriceToUse!='')
            regularPriceToUse=NumericUtilities.ParseNumber(regularPriceToUse)*value.length;
        if(value.length>0) {
            if(salePriceToUse!='') {

                return {
                    Quantity:this.GetQuantityInput(),
                    RegularPrice:regularPriceToUse,
                    SalePrice:salePriceToUse
                };
            }
            else
                return {RegularPrice:regularPriceToUse,SalePrice:'',Quantity:this.GetQuantityInput()};
        }
        else
            return {SalePrice:'',RegularPrice:'',Quantity:0}
    }





    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}